<template>

    <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0">
        <!-- left div-->
        <div :style="'height: 100%; float: left; width: ' + (100 - this.chatViewWidth) + '%'">
            <div :style="'background: black; float: left; height: 100%; width: ' + this.otherVideoWidth +'%'">
                <div :style="'width: 100%; float: left; height:' + this.adminVideoHeight + 'px'">
                    <video ref="adminVideoView" :muted="!isAdminAudioOpen" autoplay="autoplay"
                           :style="'object-fit: scale-down; float: left; margin-top:' + this.adminVideoViewMarginTop + 'px; height: ' + this.adminVideoViewHeight + 'px; width: ' + this.adminVideoViewWidth + 'px; transform: rotate(' + this.adminVideoAngle + 'deg)'"/>
                    <el-avatar v-show="this.isAdminStreamPlay" :src="this.adminAudioIcon" @click.native="openAdminAudio"
                               style="cursor: pointer; position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <el-avatar v-show="this.isAdminStreamPlay" :src="this.rotateIcon" @click.native="rotateAdminVideo"
                               style="cursor: pointer; position: absolute; margin-left: -70px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>

                    <div v-show="!this.isAdminStreamPlay" style="position: absolute; color: white; margin-top: 15px; margin-left: 10px;">管理员-离线</div>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div :style="'width: 100%; float: left; height:' + this.operaVideoHeight + 'px'">
                    <video ref="operaVideoView" autoplay="autoplay" :muted="!isOperaAudioOpen" :style="'object-fit: contain; float: left; margin-top:' + this.operaVideoViewMarginTop + 'px; height: ' + this.operaVideoViewHeight + 'px; width: ' + this.operaVideoViewWidth + 'px; transform: rotate(' + this.operaVideoAngle + 'deg)'"/>
                    <el-avatar v-show="this.isOperaStreamPlay" :src="this.operaAudioIcon" @click.native="openOperaAudio" style="cursor: pointer; position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <el-avatar v-show="this.isOperaStreamPlay" :src="this.rotateIcon" @click.native="rotateOperaVideo" style="cursor: pointer; position: absolute; margin-left: -70px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <div v-show="!this.isOperaStreamPlay" style="position: absolute; color: white; margin-top: 15px; margin-left: 10px;">手法-离线</div>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div style="position: relative; float: left; background-color: #63a35c; margin-left: 8px; margin-top: 5px" align="left">
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white">房间号：{{ this.Global.roomId }}</span>
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white; margin-top: 30px">人数：{{ this.userCount }}</span>
                </div>

            </div>

            <div ref="usView" style="background: black; float: left; height: 100%; width: 70%;">
                <div style="background: slategray; position: absolute; float: left; height: 100%; width: 1px;"/>
                <div v-show="!this.isUsStreamPlay" style="color: white; position: absolute; float: left; margin-top: 15px; margin-left: 10px;">超声-离线</div>
                <video ref="usVideoView" autoplay="autoplay" style="object-fit: contain; height: 100%; width: 100%; z-index: 1"/>
                <el-button v-show="this.isUsStreamPlay" icon="hs-icon-full-screen el-iconfont" @click="this.usVideoFullScreen" circle
                           :style="'width: 50px; height: 50px; background: transparent; position: absolute; z-index: 2; border-color: transparent; margin-left: ' + (this.chatViewWidth === 0 ? -80 : -50) + 'px'"/>
            </div>

            <div v-show="this.chatViewWidth === 0" @click="this.showChatView">
                <slot name="left">
                    <img style="cursor: pointer; width: 45px; height: 45px; background: transparent; position: absolute; top: 0; right: 0"
                         src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjA3MzI3NzE1ODQxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijg1OCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0xMDIyLjEyMjY2NjYxIDEwMzAuODI2NjY2NjdsLTI5NC45MTItMjE4LjQ1MzMzMzM0IDAtNjAwLjc0NjY2NjY2IDI5NC45MTItMjE4LjQ1MzMzMzM0TDEwMjIuMTIyNjY2NjEgMTAzMC44MjY2NjY2N3oiIGZpbGw9IiMwRDNCNTYiIHAtaWQ9Ijg1OSI+PC9wYXRoPjxwYXRoIGQ9Ik05MDQuMTU3ODY2NjEgNDM1LjU0MTMzMzMzYzMuODIyOTMzMzIgMCA3LjA5OTczMzMzIDEuNjM4NCA5LjgzMDQgNC4zNjkwNjY2NyA1LjQ2MTMzMzMzIDUuNDYxMzMzMzMgNS40NjEzMzMzMyAxNC43NDU2IDAgMjAuNzUzMDY2NjdsLTQ5LjY5ODEzMzMzIDUxLjMzNjUzMzMzIDQ5LjY5ODEzMzMzIDUxLjMzNjUzMzMzYzUuNDYxMzMzMzMgNS40NjEzMzMzMyA1LjQ2MTMzMzMzIDE0Ljc0NTYgMCAyMC43NTMwNjY2Ny01LjQ2MTMzMzMzIDUuNDYxMzMzMzMtMTQuMTk5NDY2NjcgNS40NjEzMzMzMy0xOS42NjA4IDBsLTU5LjUyODUzMzMzLTYxLjcxMzA2NjY3Yy0yLjczMDY2NjY3LTIuNzMwNjY2NjctNC4zNjkwNjY2Ny02LjU1MzYtNC4zNjkwNjY2Ny0xMC4zNzY1MzMzM3MxLjYzODQtNy42NDU4NjY2NyA0LjM2OTA2NjY3LTEwLjM3NjUzMzMzbDU5LjUyODUzMzMzLTYxLjcxMzA2NjY3YzIuNzMwNjY2NjctMi43MzA2NjY2NyA2LjU1MzYtNC4zNjkwNjY2NyA5LjgzMDQtNC4zNjkwNjY2N3oiIGZpbGw9IiNGRkZGRkYiIHAtaWQ9Ijg2MCI+PC9wYXRoPjwvc3ZnPg=="/>
                </slot>
            </div>

        </div>

        <!-- chat div--> <!-- https://blog.csdn.net/qq_31967569/article/details/107159054 -->
        <div v-show="this.chatViewWidth > 0" :style="'background: #ffffff; height: 100%; float: left; width: ' + this.chatViewWidth + '%'">
            <div :style="'height: 40px; background: #ffffff; position: absolute; z-index: 5; top: 0; width: ' + this.chatViewWidth + '%'">
                <el-button @click="this.dismissChatView" icon="el-icon-minus" circle style="background: transparent; float: left; border-color: transparent;"></el-button>
                <p style="margin-left: 40px; height: 40px; margin-top: 10px; font-size: 15px">消息</p>
            </div>

            <div ref="chatMid" :style="'background: #F5f5f5; overflow: auto; position: absolute; z-index: 10; top: 40px; bottom: 160px; width: ' + this.chatViewWidth + '%'">
                <!--        https://www.cnblogs.com/godpo/p/12009353.html-->
                <el-row>
                    <el-col>
                        <div id="chatListView" ref="chatListView" class="chatListView">
                            <div v-for="(item, index) in roomMessages" :key="index" style="padding-top: 20px">
                                <el-row v-if="item.id_name === 'myself' && item.msg_type === 1"> <!-- 类型为 text -->
                                    <el-col>
                                        <span class="rightBubble">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name === 'myself' && item.msg_type === 3"> <!-- 类型为 file -->
                                    <el-col v-if="isImageFile(item.msg_content)"> <!-- 类型为 image file -->
                                        <span class="rightImageBubble">
                                            <el-image :src="item.msg_content" style="border-radius: 5px" :preview-src-list="[item.msg_content]"/>
                                        </span>
                                    </el-col>
                                    <el-col v-else> <!-- 类型为 other file -->
                                        <span class="rightBubble">
                                            <div style="display: flex">
                                                <el-image :src="fileIcon" style="width: 30px; height: 35px;"/>
                                                <a class="right" style="margin-left: 5px; margin-top: 5px; white-space: pre-line" target="_blank" :href="item.msg_content">{{ '文件:\n' + item.msg_content.split("/")[item.msg_content.split("/").length - 1] }}</a>
                                            </div>
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name === 'time_msg'"> <!-- 时间消息 -->
                                    <el-col>
                                        <span style="font-size: 10px;">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.msg_category === 2"> <!-- 系统消息 -->
                                    <el-col>
                                        <span style="font-size: 10px; background-color: rgba(163,163,163,0.38); padding-left: 10px; padding-right: 10px; color: white; border-radius: 15px">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name !== 'myself' && item.id_name !== 'time_msg' && item.msg_category !== 2"> <!-- 收到的其他人的消息 -->
                                    <el-col :span="1">
                                        <el-avatar v-if="item.nick_name.startsWith('admin_')" :src="adminAvatar" style="margin-left: 10px; width: 25px; height: 25px"></el-avatar>
                                        <el-avatar v-else src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="margin-left: 10px; width: 25px; height: 25px"></el-avatar>
                                    </el-col>
                                    <el-col :span="23">
                                        <div style="width: 100%; height: 100%">
                                            <div style="font-size: 9px; margin-left: 30px; margin-top: -3px" align="left">{{ item.nick_name.replace("admin_", "管理员_") }}</div>
                                            <span v-if="item.msg_type === 1" class="leftBubble">{{ item.msg_content }}</span>

                                            <el-col v-if="item.msg_type === 3 && isImageFile(item.msg_content)"> <!-- 类型为 image file -->
                                                <span class="leftImageBubble">
                                                    <el-image :src="item.msg_content" style="border-radius: 5px" :preview-src-list="[item.msg_content]"/>
                                                </span>
                                            </el-col>
                                            <el-col v-if="item.msg_type === 3 && isImageFile(item.msg_content) === false"> <!-- 类型为 other file -->
                                                <span class="leftBubble">
                                                    <div style="display: flex">
                                                        <el-image :src="fileIcon" style="width: 30px; height: 35px;"/>
                                                        <a class="left" style="margin-left: 5px; margin-top: 5px; white-space: pre-line" target="_blank" :href="item.msg_content">{{ '文件:\n' + item.msg_content.split("/")[item.msg_content.split("/").length - 1] }}</a>
                                                    </div>
                                                </span>
                                            </el-col>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                
            </div>
                       
            <div :style="'height: 160px; background: #ffffff; position: absolute; z-index: 6; bottom: 0; width: ' + this.chatViewWidth + '%'">
                <div style="margin-left: 10px; margin-right: 10px; height: 100%; position: relative;">
                    <div style="width: 100%; height: 40px;">
                        <div class="image-upload" style="height: 40px; width: 13%; position: absolute;">
                            <label for="file-input" style="cursor: pointer; font-size: 20px">
                                <i class="el-icon-folder" style="margin-top: 10px"/>
                            </label>
                            <input ref="fileInput" id="file-input" type="file" @change="upload2OSS($event)"/>
                        </div>
                        <el-progress v-show="fileUploading" :percentage="uploadPercent" style="float: left; width: 85%; margin-left: 45px; margin-top: 12px"/>
                    </div>
                    <el-input ref="msgInput" type="textarea" :autosize="{minRows: 3, maxRows: 3}" placeholder="请输入内容" @keyup.native="msgInputKeyUp" :disabled="isSending" v-model="sendMessageContent" autofocus/>
                    <el-button type="primary" size="mini" style="float: right; margin-top: 5px; height: 33px; font-size: 13px" :loading="isSending" @click="sendMessage">发  送</el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {Vue} from 'vue-property-decorator';

    export default {
        extends: Vue,
        data: function () {
            return {
                userCount: 0, // 房间人数
                isSending: false, // 是否正在发送消息
                sendMessageContent: '', // 当前输入的消息内容
                roomMessages: [], // 房间消息列表
                adminAvatar: require("@/assets/admin_avatar.png"),
                adminAudioIcon: require("@/assets/audio_open.png"),
                operaAudioIcon: require("@/assets/audio_open.png"),
                rotateIcon: require("@/assets/rotate.png"),
                fileIcon: require("@/assets/icon_file.png"),
                isAdminAudioOpen: true,
                isOperaAudioOpen: true,
                isAdminStreamPlay: false, // 管理员流是否已播放
                isOperaStreamPlay: false, // 手法流是否已播放
                isUsStreamPlay: false, // 超声流是否播放
                isSystemGoBack: false, // 是否是系统回退
                fileUploading: false, // 正在上传文件
                uploadPercent: 0, // 上传进度
                chatViewWidth: 25,
                otherVideoWidth: 30,
                adminVideoHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoAngle: 0,
                operaVideoViewMarginTop: 0,
                operaVideoViewHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoViewWidth: window.innerWidth * (1.0 - (25.0 / 100.0)) * (30.0 / 100.0),
                adminVideoAngle: 0,
                adminVideoViewMarginTop: 0,
                adminVideoViewHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                adminVideoViewWidth: window.innerWidth * (1.0 - (25.0 / 100.0)) * (30.0 / 100.0)
            };
        },
        beforeRouteLeave: function (to, from, next) {
            let that = this;
            if (this.isSystemGoBack) {
                next();
            } else {
                this.$confirm('你确定要离开房间吗?', '离开房间', {
                    confirmButtonText: '确  定',
                    cancelButtonText: '取  消'
                }).then(() => {
                    that.usStreamPlayStop();
                    that.operaStreamPlayStop();
                    that.adminStreamPlayStop();
                    // 退出房间,释放资源
                    that.Global.Zego.logout();
                    // 刷新当前页面
                    next();
                }).catch(() => {
                    // 如果取消跳转地址栏会变化，这时保持地址栏不变
                    window.history.go(1);
                });
            }
        },
        mounted: function () {
            this.addZegoCallback();
            this.adminStreamPlay();
            this.usStreamPlay();
            this.operaStreamPlay();
            this.scrollChat2Bottom();
            let that = this;
            window.onresize = function () {
                that.adminVideoHeight = window.innerWidth * (that.otherVideoWidth / 100.0) * 108.0 / 192.0;
                that.operaVideoHeight = window.innerWidth * (that.otherVideoWidth / 100.0) * 108.0 / 192.0;
                that.operaVideoViewHeight = that.operaVideoHeight;
                that.operaVideoViewWidth = window.innerWidth * (1.0 - (that.chatViewWidth / 100.0)) * (that.otherVideoWidth / 100.0);
            };
        },
        methods: {
            /*
            * 上传文件到oss
            * */
            upload2OSS: function(event) {
                let that = this;
                if (this.$refs.fileInput.files.length > 0) {
                    let file = this.$refs.fileInput.files[0];
                    this.fileUploading = true;
                    this.uploadPercent = 0;
                    this.Global.OssClient.multipartUpload('chat/' + file.name, file, {
                        progress: function (percentage, cpt) {
                            that.uploadPercent = percentage * 100;
                        }
                    }).then(result => {
                        that.fileUploading = false;
                        let url = 'https://' + result.bucket + '.oss-cn-chengdu.aliyuncs.com/' + result.name;
                        that.sendFileMessage(url);
                    }).catch(err => {
                        that.fileUploading = false;
                        that.$message.info("图片发送失败错误，请重试！");
                    });
                }
            },
            /*
            * 发送文件消息
            * */
            sendFileMessage: function(url) {

                let that = this; // 闭包中无法使用this
                // msg_type: 3 文件类型
                this.Global.Zego.sendRoomMsg(1, 3, url, function (seq, msgId, msg_category, msg_type, msg_content) {
                    let message = {
                        id_name: 'myself',
                        nick_name: that.Global.ZegoConfig.nickName,
                        msg_content: msg_content,
                        send_time: new Date().getTime(),
                        msg_type: msg_type,
                        msg_category: msg_category,
                        msg_id: msgId
                    };
                    that.Global.ZegoSeq = seq;
                    that.insertTimeMessage();
                    that.roomMessages.push(message);
                    that.scrollChat2Bottom();
                }, function (err, seq, msg_category, msg_type, msg_content) {
                    that.$message.error("发送失败: " + err);
                    that.isSending = false;
                });
            },
            isImageFile: function(url) {
              return url.toLowerCase().endsWith('.jpg') || url.toLowerCase().endsWith('.jpeg') || url.toLowerCase().endsWith('.png') || url.toLowerCase().endsWith('.gif') || url.toLowerCase().endsWith('.bmp');
            },
            openAdminAudio: function() {
                if (this.Global.adminStreamID.length < 3) {
                    return;
                }
                this.isAdminAudioOpen = !this.isAdminAudioOpen;
                this.adminAudioIcon = this.isAdminAudioOpen ? require("@/assets/audio_open.png") : require("@/assets/audio_close.png");
            },
            openOperaAudio: function() {
                if (this.Global.operaStreamID.length < 3) {
                    return;
                }
                this.isOperaAudioOpen = !this.isOperaAudioOpen;
                this.operaAudioIcon = this.isOperaAudioOpen ? require("@/assets/audio_open.png") : require("@/assets/audio_close.png");
            },

            scrollChat2Bottom: function() {
              this.$nextTick(() => {
                  const chatListView = document.getElementById('chatMid');
                  chatListView.scrollTop = chatListView.scrollHeight;
              });
            },

            dismissChatView: function() {
                this.chatViewWidth = 0;
                this.adminVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoViewHeight = this.operaVideoHeight;
            },

            showChatView: function() {
                this.chatViewWidth = 25;
                this.adminVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoViewHeight = this.operaVideoHeight;
            },

            rotateOperaVideo: function() {
                if (this.operaVideoAngle % 180 === 0) {
                    this.operaVideoViewMarginTop = -(this.operaVideoViewWidth - this.operaVideoViewHeight) / 2.0;
                    this.operaVideoViewHeight = this.operaVideoViewWidth;
                } else {
                    this.operaVideoViewMarginTop = 0;
                    this.operaVideoViewHeight = this.operaVideoHeight;
                }
                this.operaVideoAngle = this.operaVideoAngle + 90;
            },
            rotateAdminVideo: function() {
                if (this.adminVideoAngle % 180 === 0) {
                    this.adminVideoViewMarginTop = -(this.adminVideoViewWidth - this.adminVideoViewHeight) / 2.0;
                    this.adminVideoViewHeight = this.adminVideoViewWidth;
                } else {
                    this.adminVideoViewMarginTop = 0;
                    this.adminVideoViewHeight = this.adminVideoHeight;
                }
                this.adminVideoAngle = this.adminVideoAngle + 90;
            },
            /*
            * 监听聊天输入框的键盘事件
            * */
            msgInputKeyUp: function(e) {
                if (e.shiftKey === true && e.keyCode === 13) { // shift + Enter
                    this.$message.info("shift + Enter");
                } else if (e.keyCode === 13) { // Enter
                    this.sendMessage();
                }
            },

            /*
            * 发送消息
            * */
            sendMessage: function() {
                if (this.sendMessageContent.trim().length === 0) {
                    this.$message.warning("发送消息不能为空！");
                    this.sendMessageContent = '';
                    this.$refs.msgInput.focus();
                    return;
                }
                this.isSending = true;
                let that = this; // 闭包中无法使用this
                this.Global.Zego.sendRoomMsg(1, 1, this.sendMessageContent, function (seq, msgId, msg_category, msg_type, msg_content) {
                    let message = {
                        id_name: 'myself',
                        nick_name: that.Global.ZegoConfig.nickName,
                        msg_content: msg_content,
                        send_time: new Date().getTime(),
                        msg_type: msg_type,
                        msg_category: msg_category,
                        msg_id: msgId
                    };
                    that.Global.ZegoSeq = seq;
                    that.insertTimeMessage();
                    that.roomMessages.push(message);
                    that.sendMessageContent = '';
                    that.scrollChat2Bottom();
                    that.isSending = false;
                    that.$nextTick(() => {
                        that.$refs.msgInput.focus();
                    });
                }, function (err, seq, msg_category, msg_type, msg_content) {
                    that.$message.error("发送失败: " + err);
                    that.isSending = false;
                });
            },

            usVideoFullScreen: function () {
                this.$refs.usVideoView.requestFullscreen();
            },

            adminStreamPlay: function () {
                if (this.Global.adminStreamID.length > 3) {
                    this.isAdminStreamPlay = this.Global.Zego.startPlayingStream(this.Global.adminStreamID, this.$refs.adminVideoView);
                }
            },
            adminStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.adminStreamID);
                this.Global.adminStreamID = '';
                this.isAdminStreamPlay = false;
            },
            usStreamPlay: function () {
                if (this.Global.usStreamID.length > 3) {
                    this.isUsStreamPlay = this.Global.Zego.startPlayingStream(this.Global.usStreamID, this.$refs.usVideoView);
                    if (this.Global.isUSLandscape) {
                        this.chatViewWidth = 0;
                    } else {
                        this.chatViewWidth = 25;
                    }
                }
            },

            usStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.usStreamID);
                this.Global.usStreamID = '';
                this.isUsStreamPlay = false;
            },

            operaStreamPlay: function () {
                if (this.Global.operaStreamID.length > 3) {
                    this.Global.Zego.startPlayingStream(this.Global.operaStreamID, this.$refs.operaVideoView);
                }
            },

            operaStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.operaStreamID);
                this.Global.operaStreamID = '';
                this.isOperaStreamPlay = false;
            },

            // 插入时间消息
            insertTimeMessage: function() {
                let isNeedInsert = false;
                if (this.roomMessages.length === 0) {
                    isNeedInsert = true;
                } else if (this.roomMessages.length > 0) {
                    let lastMsg = this.roomMessages[this.roomMessages.length - 1];
                    let lastMsgTime = lastMsg.send_time;
                    let currTime = new Date().getTime();
                    if (currTime - lastMsgTime > 5 * 60 * 1000) {
                        isNeedInsert = true;
                    }
                }
                if (isNeedInsert) {
                    let time = new Date();
                    let hour = time.getHours();
                    let min = time.getMinutes();
                    let sec = time.getSeconds();
                    let timeMessage = {
                        id_name: 'time_msg',
                        nick_name: 'Time',
                        msg_content: (hour < 10 ? "0" + hour : hour) + ":" + (min < 10 ? "0" + min : min) + ":" + (sec < 10 ? "0" + sec : sec),
                        send_time: new Date().getTime(),
                    };
                    this.roomMessages.push(timeMessage);
                }
            },

            addZegoCallback: function () {
                const that = this;

                // type Added = 0; Deleted = 1;
                this.Global.Zego.onStreamUpdated = function (type, streamList) {
                    if (streamList !== null && streamList.length > 0) {
                        streamList.forEach(item => {
                            const {stream_id, extra_info} = item;
                            if (type === 0) { // Added
                                if (stream_id.startsWith("admin_")) {
                                    if (that.Global.adminStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.adminStreamID);
                                    }
                                    that.Global.adminStreamID = stream_id;
                                    that.adminStreamPlay();
                                } else if (stream_id.startsWith("opera_")) {
                                    if (that.Global.operaStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.operaStreamID);
                                    }
                                    that.Global.operaStreamID = stream_id;
                                    that.operaStreamPlay();
                                } else if (stream_id.startsWith("us_")) {
                                    if (that.Global.usStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.usStreamID);
                                    }
                                    that.Global.usStreamID = stream_id;
                                    that.usStreamPlay();
                                    if (extra_info.indexOf("Landscape") !== -1) {
                                        that.chatViewWidth = 0;
                                    } else if (extra_info.indexOf("Portrait") !== -1) {
                                        that.chatViewWidth = 25;
                                    }
                                }
                            } else if (type === 1) { // Deleted
                                if (stream_id.startsWith("admin_")) {
                                    that.adminStreamPlayStop();
                                } else if (stream_id.startsWith("opera_")) {
                                    that.operaStreamPlayStop();
                                } else if (stream_id.startsWith("us_")) {
                                    that.usStreamPlayStop();
                                }
                            }
                        });
                    }
                };

                this.Global.Zego.onDisconnect = function (err) {
                    that.$message.info("房间连接已断开,请检查网络后重新进入！");
                    that.Global.Zego.logout();
                    that.history.go(-1);
                };

                this.Global.Zego.onUpdateOnlineCount = function (roomId, userCount) {
                    if (roomId === that.Global.roomId) {
                        that.userCount = userCount;
                    }
                };

                this.Global.Zego.onPlayStateUpdate = function (type, streamid, error) {
                    if (streamid.indexOf('us_') !== -1) {
                        that.isUsStreamPlay = (type === 0);
                    } else if (streamid.indexOf('opera_') !== -1) {
                        that.isOperaStreamPlay = (type === 0);
                    } else if (streamid.indexOf('admin_') !== -1) {
                        that.isAdminStreamPlay = (type === 0);
                    }
                };

                this.Global.Zego.onRecvCustomCommand = function (from_userid, from_idname, custom_content) {
                    if ('us_kick_out' === custom_content) {
                        that.$message.info("你被踢出房间！");
                        setTimeout(() => {
                            that.Global.Zego.logout();
                            that.isSystemGoBack = true;
                            history.go(-1);
                        }, 500);
                    }
                    if (from_userid === 'server' && custom_content === that.Global.DestoryRoomMessage) {
                        that.Global.Zego.logout();
                        that.$message.info("房间已关闭!");
                        that.isSystemGoBack = true;
                        history.go(-1);
                    }
                };

                this.Global.Zego.onUpdateOnlineCount = function (roomId, userCount) {
                    if (roomId !== that.Global.roomId) { return; }
                    that.userCount = userCount;
                };

                this.Global.Zego.onRecvRoomMsg = function (chat_data, server_msg_id, ret_msg_id) {
                    for (let i = 0; i < chat_data.length; i++) {
                        let item = chat_data[i];
                        if (2 === item.msg_category) {
                            if (that.Global.DestoryRoomMessage === item.msg_content) {
                                that.Global.Zego.logout();
                                that.$message.info("房间已关闭");
                                that.isSystemGoBack = true;
                                history.go(-1);
                                return;
                            } else {
                                that.roomMessages.push(item);
                            }
                        } else {
                            that.insertTimeMessage();
                            that.roomMessages.push(item);
                        }
                    }
                    if (chat_data.length > 0) {
                        that.scrollChat2Bottom();
                    }
                };
            },
        },
    }

</script>